export const USER_AGREEMENTS = "/UserAgreement/GetUserAgreementByCreateAcount"
export const USER_AGREEMENT_INSERT = "/UserAgreement/InsertUserAgreement"
export const USER_AGREEMENT_UPDATE = "/UserAgreement/UpdateUserAgreement"






